import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingofFabricTableThrows = () => {

    const servicesFaqData = [
        { 
            question: "What customisation options are available for fabric table throws?", 
            answer: "Printingy offers a variety of customisation options for the Printing of Fabric Table Throws, including custom sizes, vibrant full-colour printing, and fabric finishes. Our personalised table cover printing services allow you to incorporate logos, patterns, and messaging tailored to your branding needs."
        },
        { 
            question: "Does Printingy handle bulk orders for custom tablecloths?", 
            answer: "Yes, Printingy specialises in bulk custom tablecloth cover printing, ensuring cost-effective solutions and consistent quality across large orders. Bulk printing is ideal for trade shows, conferences, corporate branding, and promotional campaigns."
        },
        { 
            question: "What industries benefit from fabric table throw printing?", 
            answer: "Fabric table throws are widely used in events, exhibitions, hospitality, and corporate branding industries. Businesses use table cloth printing for trade show setups, product displays, and branded table covers. Printingy provides tailored solutions to meet the unique requirements of each industry."
        },
        { 
            question: "What materials are used for fabric table throws?", 
            answer: "We use high-quality, wrinkle-resistant fabrics for Printing of Fabric Table Throws, including polyester and other durable options. These materials are lightweight, easy to transport, and suitable for indoor and outdoor events."
        },
        { 
            question: "Can Printingy print personalised table covers with logos?", 
            answer: "Our personalised table cover services include full-colour printing with logos, graphics, and other branding elements. We ensure sharp details and vibrant colours that enhance your table display and align with your brand identity."
        },
        { 
            question: "What is the turnaround time for fabric table throw printing?", 
            answer: "Turnaround times for custom tablecloths cover printing depend on the order size and complexity. Standard bulk orders are completed within a few business days. We provide clear timelines and ensure timely delivery for larger or highly customised designs."
        },
        { 
            question: "Are the table throws durable and reusable?", 
            answer: "Yes, our fabric table throws are made from high-quality, durable materials that are reusable and long-lasting. They are wrinkle-resistant, easy to clean, and maintain a professional appearance after multiple uses."
        },
        { 
            question: "Does Printingy offer eco-friendly printing for tablecloths?", 
            answer: "Yes, Printingy offers eco-friendly options for tablecloth printing, including sustainable materials and non-toxic inks. These options are ideal for businesses looking for environmentally conscious solutions."
        },
        { 
            question: "What factors should I consider when ordering fabric table throws?", 
            answer: "When ordering Printing of Fabric Table Throws, consider the table size, design layout, and fabric type. Choosing the right dimensions and printing finish ensures a polished and professional display that enhances your event or promotion."
        },
        { 
            question: "How do I place an order for table throw printing?", 
            answer: "Placing an order is easy. Visit our website and select your preferences for custom tablecloth cover printing, including sizes, colours, and designs. Upload your artwork, and our team will assist you from design approval to delivery."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Fabric Table Throws');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Fabric Table Throws and Tablecloth Printing Services"
  description="Professional printing of fabric table throws, tablecloths, and personalised table covers. Bulk custom tablecloth covers printing for events and branding."
  keywords="Printing of Fabric Table Throws,
Table cloth printing,
Custom tablecloths cover printing,
Personalised table cover printing

"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Fabric Table Throws</h1>
              <h2 className="text-muted">
              Custom tablecloths and personalised table covers for events and branding
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Fabric table throws enhance event displays, trade shows, and promotional setups. Printingy offers premium Printing of Fabric Table Throws services, specialising in tablecloth printing, custom tablecloth cover printing, and personalised table cover printing tailored to your needs.</p>
          <p>Our high-quality table throws provide a sleek and professional look for tables at events, exhibitions, and conferences. With options for vibrant prints, custom sizes, and durable materials, we ensure that your branding stands out and leaves a lasting impression.</p>
          <p>Whether for product displays, corporate events, or branding campaigns, Printingy delivers reliable and cost-effective table throw printing solutions. Trust us to elevate your presentation with precision and consistency in every order.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable and Durable Table Throw Printing Solutions</h2>
                <h3 className="large-hed">High-quality, customisable, and professional tablecloth cover printing</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Fabric Table Throws for sleek, branded displays.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-quality tablecloth printing with sharp graphics and vibrant colours.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk custom tablecloths cover printing for cost-effective solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Personalised designs for personalised table covers printing needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable, wrinkle-resistant, and reusable materials for long-term use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for accurate details and colour consistency.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnarounds and efficient bulk order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by event organisers, exhibitors, and businesses nationwide.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/tablethrows.jpg" // Path relative to the public folder
                  alt="Professional tablecloth printing services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Table Throws Delivered On Time</h2>
            <h3 className="small-hed">Focus on your event while we manage your tablecloth printing needs</h3>
            <p>Printingy uses advanced printing technology and durable materials to provide exceptional custom tablecloth cover printing services. Whether for trade shows, promotional events, or retail displays, our Printing of Fabric Table Throws ensures professional and consistent results for every order.</p>
            <p>Focusing on quality and efficiency, we guarantee timely delivery even for bulk orders. Partner with Printingy to create professional table throws and tablecloths that enhance your event presence and branding.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingofFabricTableThrows;
